// extracted by mini-css-extract-plugin
export var legendIndicator = "_9u-1";
export var legendRight = "_9u-0";